import { CustomerLogo } from '@sequencehq/core-components'

import { getLogoSrc } from 'Customer/index'
import { getHumanReadableInvoiceNumber } from 'Invoices/utils'
import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'

export const InvoiceAutoIssueFailedListItem = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon } =
    useManualTaskListItemContentToolkit<TaskInput>({
      taskId
    })

  const { invoice, customer } = useInvoiceData(manualTask?.input?.invoiceId)

  if (!manualTask || !invoice) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      title={`${getHumanReadableInvoiceNumber({
        invoiceNumber: invoice.invoiceNumber,
        invoiceStatus: invoice.status
      })}: Auto-issue failed`}
      description={`Add a billing email for ${invoice.customerLegalCompanyName} to issue this invoice`}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={customer ? getLogoSrc(customer) : undefined}
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
